module.exports = __webpack_public_path__ + "static/ha7-477b7f443e246b5133d960d645e34c73.jpg";